import { render, staticRenderFns } from "./RotorSailControl.vue?vue&type=template&id=2d3e1c70&scoped=true&"
import script from "./RotorSailControl.vue?vue&type=script&lang=js&"
export * from "./RotorSailControl.vue?vue&type=script&lang=js&"
import style0 from "./RotorSailControl.vue?vue&type=style&index=0&id=2d3e1c70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3e1c70",
  null
  
)

export default component.exports